import type { MailboxInfo } from "owa-client-types";
import { isBizchatSSRFeatureEnabledForMailbox } from "./isBizchatSSRFeatureEnabledForMailbox";
import { prefetchSSRTokenUtil } from "./prefetchSSRTokenUtil";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";

export const prefetchSSRTokenForAutoOpen = async (mailboxInfo: MailboxInfo): Promise<void> => {
    if (isBizchatSSRFeatureEnabledForMailbox(mailboxInfo) &&
        isServiceRequestSupportedForMailbox(mailboxInfo)) {
        prefetchSSRTokenUtil(mailboxInfo);
    }
};
